import React from 'react'

import {
    autoComponents,
    Dashboard,
    legendComponents,
    LegendDashboard,
    loyaltyComponents,
} from 'components/Dashboard'
import useAppSelector from 'hooks/useAppSelector'
import useUser from 'hooks/useUser'
import ErrorPage from 'pages/ErrorPage'
import LoadingPage from 'pages/LoadingPage/LoadingPage'
import AssetType from 'state/enums/AssetType'
import LoadingStatus from 'state/enums/LoadingStatus'

import ParseDashboard from '../../state/dashboard/parsers/ParseDashboard'
import { autoDashboardFallback } from './DashboardFallbackData'

export default function DashboardPage(): JSX.Element {
    const { user, status: userStatus, assetTypes } = useUser()

    const { dashboardData: loadedDashboardData, status: dashboardStatus } =
        useAppSelector((state) => state.dashboard) || {}

    let dashboardData = loadedDashboardData

    const hasAutoAssetType = assetTypes.some(
        (type) => type === AssetType.AUTOMOBILE,
    )

    if (
        userStatus !== LoadingStatus.LOADED &&
        dashboardStatus !== LoadingStatus.LOADED &&
        userStatus !== LoadingStatus.FAILED &&
        dashboardStatus !== LoadingStatus.FAILED
    ) {
        return <LoadingPage />
    }

    if (!dashboardData?.dashboard && hasAutoAssetType) {
        dashboardData = ParseDashboard(autoDashboardFallback)
    }

    const dealership = user?.dealership

    if (
        !dashboardData?.dashboard ||
        userStatus === LoadingStatus.FAILED ||
        dashboardStatus === LoadingStatus.FAILED
    ) {
        return (
            <ErrorPage
                title="Failed to load dashboard"
                body={
                    'Failed to load dashboard as data is missing. ' +
                    'If the problem persists, please contact support.'
                }
                errorData={{
                    error: new Error(
                        'Failed to load dashboard as data is missing.',
                    ),
                    context: {
                        user: { uuid: user?.uuid },
                        dealership: { id: dealership?.id },
                    },
                }}
            />
        )
    }

    let components
    let DashboardType = Dashboard

    if (hasAutoAssetType) {
        components = autoComponents
    } else if (dashboardData?.dashboard?.type === 'legend') {
        DashboardType = LegendDashboard
        components = legendComponents
    } else {
        components = loyaltyComponents
    }

    return (
        <div>
            <DashboardType
                data={dashboardData}
                components={components}
                dealershipName={dealership?.name || ''}
            />
        </div>
    )
}
